import {
  formatDenominatedNumber,
  getFarmContractName
} from 'helpers/mvx/formatters';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import BigNumber from 'bignumber.js';
import { SnapshotChart } from 'components/SnapshotChart';

export const Snapshots = ({ address }: { address?: string }) => {
  const rawVestaConfig = useSelector(
    (state: RootState) => state.rawVesta.config
  );

  const isEarningRewards = (lpAmount: string, target: string) =>
    new BigNumber(lpAmount).isGreaterThan(new BigNumber(target));

  return (
    <div className='card'>
      <div className='card-header'>
        Snapshot Info {getFarmContractName(address ?? '')}
      </div>
      {address === undefined && (
        <div className='card-body'>
          <div className='text-center'>
            Click on an address from Farm Addresses to load the snapshot
          </div>
        </div>
      )}

      {address !== undefined && (
        <div className='card-body'>
          <div className='text-center mb-3'>
            <h5>
              Showing {(rawVestaConfig.data?.snapshots || {})[address].length}{' '}
              snapshot entries
            </h5>
          </div>
          {rawVestaConfig.data?.snapshots !== null &&
            rawVestaConfig.data?.snapshots !== undefined && (
              <div className='w-100 mb-3' style={{ height: '150px' }}>
                {rawVestaConfig.data.snapshots[address] !== undefined &&
                  rawVestaConfig.data.snapshots[address].length > 0 && (
                    <SnapshotChart
                      snapshotData={rawVestaConfig.data.snapshots[address]}
                    />
                  )}
              </div>
            )}
          <div className='table-responsive'>
            <table className='table'>
              <thead>
                <tr>
                  <th scope='col'>Epoch</th>
                  <th scope='col'>vEGLD Farm liquidity</th>
                  <th scope='col'>Pool weight</th>
                  <th scope='col'>Weighted amount</th>
                  <th scope='col'>vEGLD earn treshold</th>
                </tr>
              </thead>
              <tbody>
                {(rawVestaConfig.data?.snapshots || {})[address].map(
                  (snapshotEntry, i) => (
                    <tr
                      key={`snapshot-entry-${address}-${i}-${snapshotEntry.epoch}`}
                    >
                      <th
                        className={
                          isEarningRewards(
                            snapshotEntry.snapshotInfo.lp_vegld_amount,
                            snapshotEntry.snapshotInfo
                              .min_vegld_liquidity_treshold
                          )
                            ? 'bg-success'
                            : 'bg-danger'
                        }
                      >
                        {snapshotEntry.epoch}
                      </th>
                      <td>
                        {formatDenominatedNumber(
                          snapshotEntry.snapshotInfo.lp_vegld_amount
                        )}
                      </td>
                      <td>
                        {formatDenominatedNumber(
                          snapshotEntry.snapshotInfo.pool_weight
                        )}
                      </td>
                      <td>
                        {formatDenominatedNumber(
                          snapshotEntry.snapshotInfo.weighted_amount
                        )}
                      </td>
                      <td>
                        {formatDenominatedNumber(
                          snapshotEntry.snapshotInfo
                            .min_vegld_liquidity_treshold
                        )}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
